import {
  ForumClient
} from '../clients/ForumClient';

export const ForumModule = {
  state: {
    forum: [],
    errors: [],
    topics: {},
    loadedTopics: [],
    openTopics: [],
    hasLoaded: false
  },

  getters: {},
  mutations: {
    //synchronous
    SET_LOADED(state, payload) {
      state.hasLoaded = payload
    },
    SET_ERRORS: (state, errors) => {
      state.errors = errors;
    },
    SET_FORUM: (state, forum) => {
      state.forum = forum;
    },
    SET_TOPIC(state, payload) {
      state.topics[payload.id] = payload
      state.loadedTopics.push(payload.id)
      state.openTopics.push(payload.id)
    },
    SET_OPEN_TOPIC(state, payload) {
      if (state.openTopics.includes(payload)) {
        return
      } else {
        state.openTopics.push(payload)
      }
    },
    REMOVE_OPEN_TOPIC(state, payload) {
      if (state.openTopics.includes(payload)) {
        state.openTopics.splice(state.openTopics.indexOf(payload));
      } else {
        return
      }
    }
  },

  actions: {
    openTopic({
      commit
    }, payload) {
      commit('SET_OPEN_TOPIC', payload)
    },
    closeTopic({
      commit
    }, payload) {
      commit('REMOVE_OPEN_TOPIC', payload)
    },
    getTopic({
      commit
    }, payload) {
      ForumClient.getTopic(payload.forumId, payload.topicId).then((response) => {
        console.log(response.data.topic);

        commit('SET_TOPIC', response.data.topic)

      }).catch((err) => {
        console.log(err)
      });
    },
    //asynchronous
    GET_FORUM: async ({
      commit
    }, payload) => {
      commit("SET_LOADED", false)
      return ForumClient.getForum(payload)
        .then(function (res) {
          commit('SET_FORUM', res.data.forum);
        })
        .catch(function () {}).then(() => {
          commit('SET_LOADED', true)
        });
    },
    ADD_POST_TO_TOPIC: async ({
      commit,
      dispatch
    }, payload) => {
      return ForumClient.addPost(payload)
        .then(function (res) {
          dispatch('ADD_POST_TO_DOCUMENT', res.data.data);
        })
        .catch(function () {});
    },

    // ADD_DOCUMENT_TO_FORUM: async ({ commit }, payload) => {
    //   return DocumentClient.addToForum(payload.document, payload.forum)
    //     .then(function(res) {
    //       commit('UNSET_DOCUMENTS');
    //       commit('SET_DOCUMENT', res.data.document);
    //     })
    //     .catch(function(err) {
    //       commit('SET_ERRORS', err.response.data.errors);
    //     });
    // },
  },
};